import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import { Button, H1, Spinner } from '../../components/';
import Input from '../formInputs/Input';
import EmailSent from '../../migrate/recovery/EmailSent';
import ImportAccountModal from '../../user/importAccountModal/ImportAccountModal';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { required, email, notEmail } from '~APP_UTIL/formValidations';

import { setUserResetEmail } from '../../migrate/actions';

export class PasswordRecover extends Component {
  constructor(props) {
    super(props);

    this.state = {
      emailSent: false
    };
  }

  setEmailSent = bool => this.setState({ emailSent: bool });

  handleSubmit = () => {
    const {
      form: { values },
      passwordRecover,
      history,
      isLegacy,
      isModal,
      setUserResetEmail
    } = this.props;

    setUserResetEmail(values.passwordResetUsername.toLowerCase());

    passwordRecover({ username: values.passwordResetUsername.toLowerCase() });
    this.setEmailSent(true);
    if (!isModal) {
      history.push(isLegacy ? '/legacy/password/sent' : '/password/sent');
    }
  };

  render() {
    const { form, submitting, handleSubmit, isLegacy, isModal } = this.props;
    const { emailSent } = this.state;

    return (
      <div className='flex-container center ta-sm-c'>
        {emailSent && <EmailSent type='password' isModal />}
        {!emailSent && (
          <form onSubmit={handleSubmit(() => this.handleSubmit())}>
            <H1 className='mt6-sm'>
              <TranslatedCopy id='password.recover.title' />
            </H1>
            <p className='body-4 pt7-sm pb7-sm text-color-secondary'>
              <TranslatedCopy id='migrate.user.resetPassword.copy' />
            </p>
            <div>
              <Field
                name='passwordResetUsername'
                type='text'
                component={Input}
                label={isLegacy ? 'Username' : 'Email'}
                validate={isLegacy ? [required, notEmail] : [required, email]}
                placeholder={`Please enter your ${isLegacy ? 'username' : 'email address'}`}
              />
              <div className='flex-container align-center mt3-sm'>
                <Button
                  type='submit'
                  disabled={form && form.syncErrors}
                  extraClassName='pt2-sm pr5-sm pb2-sm pl5-sm ncss-btn-primary-dark u-full-width'
                  color='border-grey'
                  data-desc='passwordReset__form-submit'
                >
                  {submitting ? (
                    <Spinner className='relative-container p3-sm' />
                  ) : (
                    <TranslatedCopy id='migrate.user.resetPassword.button' />
                  )}
                </Button>
              </div>
            </div>
          </form>
        )}
        {isModal && (
          <div className='pt4-sm'>
            <ImportAccountModal />
          </div>
        )}
      </div>
    );
  }
}

PasswordRecover.defaultProps = {
  form: null,
  history: null,
  isModal: false
};

PasswordRecover.propTypes = {
  form: PropTypes.any,
  history: ReactRouterPropTypes.history,
  isModal: PropTypes.bool,
  passwordRecover: PropTypes.func.isRequired,
  setUserResetEmail: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  isLegacy: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  form: state.form.passwordRecover
});

const connector = connect(mapStateToProps, {
  setUserResetEmail
});

export default reduxForm({
  form: 'passwordRecover'
})(connector(PasswordRecover));
